import PropTypes from 'prop-types'

const inputProptypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  internClassName: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  fixedLabel: PropTypes.bool,

  // Event and State Properties
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onFieldValidation: PropTypes.func,
  customButton: PropTypes.object,

  // Validate Properties
  errorMessage: PropTypes.string,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  requiredSymbol: PropTypes.string,
  requiredMessage: PropTypes.string,
  validMessage: PropTypes.string,
  maxLength: PropTypes.number,
  type: PropTypes.string,

  // Accessibility Properties
  tabIndex: PropTypes.number,
}

export default inputProptypes
